import React, { Component } from 'react';
import { Query } from "react-apollo"
import gql from "graphql-tag"

export default () => WrappedComponent => class WithSiteMeta extends Component {
  render() {
    return (
      <Query
        query={gql`
            {
              siteMeta{
                frontPageSlug
                notFoundSlug
                homeUrl
              }
            }`
        }
      >
        {({ loading, error, data }) => (
          <div>
            {!error &&
              <WrappedComponent
                {...this.props}
                siteMetaLoading={loading}
                siteMeta={!loading && !error && data.siteMeta}
              />
            }
            {error && <h1>Error: {error.message}</h1>}
          </div>
        )}
      </Query>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/withSiteMeta.js